// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AYH-T","colBig":"styles_colBig__2DlxA","colSmall":"styles_colSmall__3Ipxc","shopifyNameWrapper":"styles_shopifyNameWrapper__2mQNr"};